import { FC } from 'react'
import { BsPersonSquare } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import { selectRole } from '../../../../../../slices/authSlice'

type Props = {
  iconColor: string
  contactAddress: ContactAddressType
}

const ProfileImage: FC<Props> = (props) => {
  const { iconColor, contactAddress } = props

  const navigate = useNavigate()

  const role = useSelector(selectRole)
  const target = role === 2 ? 'shared' : 'personal'

  return (
    <div
      className={
        target === contactAddress.category ? 'profile-image' : undefined
      }
      onClick={() => {
        target === contactAddress.category &&
          navigate(`/uploadProfileImage/${contactAddress.id}`)
      }}
    >
      {contactAddress?.profileImage ? (
        <img
          src={`data: ${contactAddress?.mimeType}; base64, ${contactAddress.profileImage}`}
          alt="プロフィール画像"
          width="60"
          height="60"
        />
      ) : (
        <BsPersonSquare size="60" color={iconColor} />
      )}
    </div>
  )
}

export default ProfileImage
